module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "t_h"
  }, [_vm._v("Section 1:")])]), _vm._v(" Shunting Locomotives")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec1-1"
    }
  }, [_vm._v("1.1: Pre-Nationalization Designs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec1-2"
    }
  }, [_vm._v("1.2: Post-Nationalization Designs")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "t_h"
  }, [_vm._v("Section 2:")])]), _vm._v(" Main Line Locomotives")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1: Type 1 Designs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2: Type 2 Designs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3: Type 3 Designs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter021#sec2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4: Type 4 Designs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter021#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.5: Type 5 Designs")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "t_h"
  }, [_vm._v("Section 3:")])]), _vm._v(" Heritage Centres")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1: Barrow Hill Roundhouse (BHR)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2: Bo’ness & Kinneil Railway (BKR)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3: Embsay & Bolton Abbey Railway (EBAR)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4: East Lancashire Railway (ELR)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5: Great Central Railway (GCR)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6: Keighley & Worth Valley Railway (KWVR)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.7: Severn Valley Railway (SVR)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0